import React from 'react';
import s from '../../pages/PDV.module.css';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ModalTotaisCaixa({ modalTotais, setModalTotais, carregandoTotais, totaisCaixa, onImprimir }) {
  if (!modalTotais) return null;
  return (
        <div className={s.modalOverlay} onClick={() => setModalTotais(false)}>
          <div className={s.modalTotaisCaixa} onClick={e => e.stopPropagation()}>
            <div className={s.modalTitleBar}>
              <span>Totais em Caixa — Relatório de Fechamento</span>
              <button className={s.modalClose} onClick={() => setModalTotais(false)}>✕</button>
            </div>
            <div className={s.totaisBody}>
              {carregandoTotais ? (
                <p style={{ padding: '12px', color: '#666' }}>Carregando...</p>
              ) : !totaisCaixa?.turno ? (
                <p style={{ padding: '16px', color: '#b91c1c', textAlign: 'center' }}>
                  Nenhum caixa aberto. Abra o caixa para visualizar os totais do turno.
                </p>
              ) : (
                <>
                  {totaisCaixa.turno && (
                    <p style={{ padding: '6px 12px 2px', fontSize: 11, color: '#666' }}>
                      Turno #{totaisCaixa.turno.id} — aberto em{' '}
                      {new Date(totaisCaixa.turno.abertura_em).toLocaleString('pt-BR')}
                      {totaisCaixa.saldo_abertura > 0 && ` — Suprimento: ${fmtBRL(totaisCaixa.saldo_abertura)}`}
                    </p>
                  )}
                  <table className={s.totaisGrid}>
                    <thead>
                      <tr><th>Forma de Pagamento</th><th className={s.right}>Valor R$</th></tr>
                    </thead>
                    <tbody>
                      {totaisCaixa.formas?.length > 0
                        ? totaisCaixa.formas.map(f => (
                            <tr key={f.forma}>
                              <td>{f.forma}</td>
                              <td className={s.right}>{fmtBRL(f.total)}</td>
                            </tr>
                          ))
                        : <tr><td colSpan={2} style={{ color: '#999', textAlign: 'center' }}>Nenhuma venda neste turno</td></tr>
                      }
                      <tr className={s.totaisSep}>
                        <td>Total de devoluções</td>
                        <td className={s.right}>{fmtBRL(totaisCaixa?.devolucoes ?? 0)}</td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr className={s.totaisTotal}>
                        <td><strong>Total Geral</strong></td>
                        <td className={s.right}><strong>{fmtBRL(totaisCaixa?.total_geral ?? 0)}</strong></td>
                      </tr>
                    </tfoot>
                  </table>
                </>
              )}
              {totaisCaixa?.atualizado_em && (
                <p className={s.totaisObs}>
                  Atualizado: {new Date(totaisCaixa.atualizado_em).toLocaleTimeString('pt-BR')}
                </p>
              )}
            </div>
            <div className={s.modalFooter} style={{justifyContent:'flex-end'}}>
              {totaisCaixa?.turno && (
                <button className={s.btnCancelarModal} onClick={onImprimir}
                  title="Imprime na térmica os totais por forma de pagamento — conferência parcial, o turno continua aberto">
                  🖨️ Imprimir
                </button>
              )}
              <button className={s.btnCancelarModal} onClick={() => setModalTotais(false)}>Fechar</button>
            </div>
          </div>
        </div>
  );
}
